<template>
  <v-dialog v-model="showDialog" transition="dialog-top-transition" :max-width="maxWidth">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-subtitle v-if="subtitle" class="mt-2">
        <span class="font-weight-bold">{{ subtitle }}</span>
      </v-card-subtitle>
      <v-card-text v-html="message" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="flat"
          color="primary"
          class="ma-2"
          size="large"
          data-cy="confirm-button"
          @click.stop="confirmClick()"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
const emit = defineEmits(['close']);
const props = withDefaults(
  defineProps<{ dialogVisible: boolean; title: string; subtitle?: string; message: string; maxWidth?: number }>(),
  { dialogVisible: false, title: 'Information', subtitle: undefined, message: '', maxWidth: 400 },
);
const showDialog = computed<boolean>({
  get() {
    return props.dialogVisible;
  },
  set(value: boolean) {
    if (!value) {
      emit('close');
    }
  },
});
const closeDialog = (): void => {
  showDialog.value = false;
};
const confirmClick = (): void => closeDialog();
</script>
